import { useDispatch } from "react-redux";
import { utilityAction } from "reduxStore";

const useMsgBox = () => {
  const dispatch = useDispatch();

  const resetDialog = () => {
    dispatch(utilityAction.showMsgBox({ show: false }));
  };

  const showMsg = (title, msg) =>
    new Promise((resolve) => {
      dispatch(
        utilityAction.showMsgBox({
          show: true,
          title,
          message: msg,
          allowClose: true,
          closeLabel: "Tutup",
          doHandle: null,
          doLabel: "",
          linkTo: "",
          linkToLabel: "",
          callBackOnClose: () => {
            resetDialog();
            resolve(true);
          },
        }),
      );
    });

  const confirmMsg = (title, msg) =>
    new Promise((resolve) => {
      dispatch(
        utilityAction.showMsgBox({
          show: true,
          title,
          message: msg,
          allowClose: true,
          doLabel: "Ya",
          doHandle: () => {
            resetDialog();
            resolve(true);
          },
          closeLabel: "Tidak",
          linkTo: "",
          linkToLabel: "",
          callBackOnClose: () => {
            resetDialog();
            resolve(false);
          },
        }),
      );
    });

  return [showMsg, confirmMsg];
};

export default useMsgBox;
